import styled, { css } from 'styled-components/macro';

import { colors } from '../../styles/vars';

const triangleDown = css`
  top: 100%;
  left: 50%;
  border-top: none;
  border-left: none;
`;

const triangleUp = css`
  top: 0;
  left: 50%;
  border-bottom: none;
  border-right: none;
`;

const triangleRight = css`
  top: 50%;
  left: 100%;
  border-bottom: none;
  border-left: none;
`;

const triangleLeft = css`
  top: 50%;
  left: 0;
  border-top: none;
  border-right: none;
`;

const centerVertical = () => css`
  top: -${props => ((props.height / 2) - (props.parentHeight / 2))}px;
`;

const centerHorizontal = () => css`
  left: -${props => ((props.width / 2) - (props.parentWidth / 2))}px;
`;

const center = position => ((position === 'left' || position === 'right') ? centerVertical() : centerHorizontal());

const getPosition = (position) => {
  let positionRelativeToParent;

  switch (position) {
    case 'top':
      positionRelativeToParent = 'bottom';
      break;
    case 'right':
      positionRelativeToParent = 'left';
      break;
    case 'bottom':
      positionRelativeToParent = 'top';
      break;
    case 'left':
      positionRelativeToParent = 'right';
      break;
    default:
      break;
  }

  return `${positionRelativeToParent}: calc(100% + 7px);`;
};

const StyledPopup = styled.div`
  position: absolute;
  ${props => center(props.position)}
  ${props => getPosition(props.position)}
  z-index: 10;
  display: flex;
  padding: 12px 15px;
  background-color: #3d3234;
  box-shadow: 0 4px 8px 0 rgba(40, 40, 46, 0.3);
  border: solid 1px ${colors['pale-grey']};
  border-radius: 2px;

  &::after {
    content: '';
    position: absolute;
    width: 13px;
    height: 13px;
    border: 1px solid ${colors['pale-grey']};
    background-color: #3d3234;
    transform: translate(-50%, -50%) rotate(45deg);
    ${props => props.position === 'top' && triangleDown}
    ${props => props.position === 'right' && triangleLeft}
    ${props => props.position === 'bottom' && triangleUp}
    ${props => props.position === 'left' && triangleRight}
  }
`;

export default StyledPopup;
